import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import Link from '@tiptap/extension-link'
import Image from '@tiptap/extension-image'
import Placeholder from '@tiptap/extension-placeholder'
import TextStyle from '@tiptap/extension-text-style'
import Color from '@tiptap/extension-color'
import FontFamily from '@tiptap/extension-font-family'
import Highlight from '@tiptap/extension-highlight'
import TextAlign from '@tiptap/extension-text-align'
import Subscript from '@tiptap/extension-subscript'
import Superscript from '@tiptap/extension-superscript'
import Details from '@tiptap/extension-details'
import DetailsSummary from '@tiptap/extension-details-summary'
import DetailsContent from '@tiptap/extension-details-content'

const linkAttrs = {
  rel: 'noopener noreferrer nofollow',
  class: 'text-nk-sea underline decoration-nk-sea/40 underline-offset-2',
}

const imageAttrs = {
  loading: 'lazy' as const,
  class: 'rounded-lg border border-nk-fog max-h-[560px] w-auto',
}

function detailsExtensions() {
  return [
    DetailsSummary.configure({
      HTMLAttributes: {
        class:
          'nk-details-summary inline-block min-w-[8rem] cursor-pointer select-none rounded px-2 py-1 text-[13px] font-extrabold text-nk-ink outline-none focus-visible:ring-2 focus-visible:ring-nk-sea focus-visible:ring-offset-2',
      },
    }),
    DetailsContent.configure({
      HTMLAttributes: {
        class: 'nk-details-body border-t border-nk-fog bg-white px-3 py-2 text-nk-navy',
      },
    }),
    Details.configure({
      persist: false,
      openClassName: 'nk-details-open',
      HTMLAttributes: {
        class: 'nk-details my-3 rounded-lg border-2 border-nk-fog bg-nk-panel shadow-sm',
      },
    }),
  ]
}

export function forumReaderExtensions() {
  return [
    StarterKit.configure({
      heading: { levels: [1, 2, 3] },
    }),
    TextStyle,
    Color.configure({ types: ['textStyle'] }),
    FontFamily.configure({ types: ['textStyle'] }),
    Highlight.configure({
      multicolor: true,
      HTMLAttributes: { class: 'rounded-sm px-0.5' },
    }),
    TextAlign.configure({
      types: ['heading', 'paragraph'],
      alignments: ['left', 'center', 'right', 'justify'],
    }),
    Underline,
    Subscript,
    Superscript,
    ...detailsExtensions(),
    Link.configure({
      openOnClick: false,
      autolink: false,
      linkOnPaste: false,
      HTMLAttributes: linkAttrs,
      validate(href: string): boolean {
        try {
          const u = new URL(href)
          return u.protocol === 'https:' || u.protocol === 'mailto:'
        } catch {
          return false
        }
      },
    }),
    Image.configure({
      HTMLAttributes: imageAttrs,
      allowBase64: false,
      inline: false,
    }),
  ]
}

export function forumTipTapExtensions(placeholder?: string) {
  return [
    StarterKit.configure({
      heading: { levels: [1, 2, 3] },
    }),
    TextStyle,
    Color.configure({ types: ['textStyle'] }),
    FontFamily.configure({ types: ['textStyle'] }),
    Highlight.configure({
      multicolor: true,
      HTMLAttributes: { class: 'rounded-sm px-0.5' },
    }),
    TextAlign.configure({
      types: ['heading', 'paragraph'],
      alignments: ['left', 'center', 'right', 'justify'],
    }),
    Underline,
    Subscript,
    Superscript,
    ...detailsExtensions(),
    Placeholder.configure({
      placeholder:
        placeholder ?? 'Write like you are at the kitchen table: clear, neighborly, and kind.',
    }),
    Link.configure({
      openOnClick: false,
      autolink: true,
      linkOnPaste: true,
      HTMLAttributes: linkAttrs,
      validate(href: string): boolean {
        try {
          const u = new URL(href)
          return u.protocol === 'https:' || u.protocol === 'mailto:'
        } catch {
          return false
        }
      },
    }),
    Image.configure({
      HTMLAttributes: imageAttrs,
      allowBase64: false,
      inline: false,
    }),
  ]
}
